export interface TrackerMetadata
{
    custom_name?: string;
}

export class SetCustomTrackerNameDto
{
    custom_name!: string;
}